/**
 * List Schema of FormatoArquivoRelatorio
 * @author Simpli CLI generator
 */
import {
  Helper,
  Schema,
  FieldSet,
  FieldComponent,
  Component,
} from 'simpli-web-sdk'
import {FormatoArquivoRelatorio} from '@/model/resource/FormatoArquivoRelatorio'

/* TODO: review generated schema */
export class ListFormatoArquivoRelatorioSchema extends Schema {
  readonly name = 'ListFormatoArquivoRelatorio'

  readonly fieldSet: FieldSet<FormatoArquivoRelatorio> = {
    idFormatoArquivoRelatorioPk: (): FieldComponent => ({
      is: Component.Render,
    }),
    descricao: (): FieldComponent => ({
      is: Component.Render,
    }),
  }
}
